import './styles/_lookbook.scss';
import 'swiper/swiper-bundle.css';
import { onDocumentReady } from '@/utils/dom';
import initLookbook from './lookbook';

const getActiveSlideFromWindowUrl = () => {
  const { href } = window.location;
  const url = new URL(href);
  const activeSlide = url.searchParams.get("activeSlide");
  return activeSlide;
};

const currentSlide = getActiveSlideFromWindowUrl();

onDocumentReady(() => {
  initLookbook(currentSlide);
});